import api from "./axios"; // ton axios instance (baseURL + token)

// NB : l'instance axios importée ci-dessus a déjà pour baseURL "/api/v1"
// (voir src/api/axios.js). Les chemins ci-dessous ne doivent donc PAS
// répéter ce préfixe (sans quoi l'appel réel part sur /api/v1/api/v1/...
// et échoue en 404) -- convention déjà suivie partout ailleurs dans le
// frontend (ex. Reservations.js : api.post("/reservations", ...)).
export const ReservationsAPI = {
  list: (params) => api.get("/reservations", { params }),
  get: (id) => api.get(`/reservations/${id}`),

  stop: (id) => api.post(`/reservations/${id}/stop`),

  // optionnel si tu as déjà un endpoint "status"
  // status: (id) => api.get(`/reservations/${id}/status`),
};
